<template>
  <v-container fluid>
    <v-layout xs12 align-start row wrap>
      <v-flex xs12 sm12 md12 justify-center>
        <h2 class="ml-2 mb-2">{{ titulo }}</h2>
        <v-data-table
          :headers="headers"
          :items="$apollo.data.products"
          :loading="$apollo.loading"
          :expanded.sync="expanded"
          show-expand
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat height="135">
              <div class="md8 mr-11 ml-2 row sm10 xs10">
                <v-flex xs12 sm6 md2 py-3>
                  <v-autocomplete
                    v-model="filters.id_drugstore"
                    v-bind:items="toArray(list_drugstores)"
                    id="id_drugstore"
                    label="Farmácia*"
                    item-text="name"
                    item-value="id"
                    :rules="rules"
                    required
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md2 py-3>
                  <v-text-field
                    v-model="filters.name"
                    flat
                    hide-details
                    label="Nome"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2 py-3>
                  <v-text-field
                    v-model="filters.brand"
                    flat
                    hide-details
                    label="Marca"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2 py-3>
                  <v-text-field
                    v-model="filters.stripe"
                    flat
                    hide-details
                    label="Tarja"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2 py-3>
                  <v-text-field
                    v-model="filters.ean1"
                    flat
                    hide-details
                    label="Cod. de Barras"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 py-3>
                  <v-text-field
                    v-model="filters.information"
                    flat
                    hide-details
                    label="Informação"
                  ></v-text-field>
                </v-flex>
              </div>
              <v-dialog
                v-model="dialog"
                max-width="1200px"
                v-if="user_role && user_role.role == 'admin'"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on"
                    >Adicionar</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form
                        ref="form"
                        v-model="valid"
                        :lazy-validation="lazy"
                      >
                        <v-row>
                          <v-col cols="12" md="12">
                            <ApolloQuery
                              :query="
                                gql => gql`
                                  query ListCategories {
                                    categories(
                                      where: { isenabled: { _eq: true } }
                                      order_by: { name: asc }
                                    ) {
                                      id
                                      name
                                      category {
                                        name
                                        id
                                        category {
                                          name
                                          id
                                          category {
                                            name
                                            id
                                            category {
                                              name
                                              id
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                `
                              "
                            >
                              <template v-slot="{ result: { data } }">
                                <v-autocomplete
                                  v-if="data"
                                  v-model="arrayCategories"
                                  v-bind:items="toArray(data.categories)"
                                  filled
                                  label="Categorias*"
                                  item-text="name"
                                  item-value="id"
                                  multiple
                                >
                                  <template v-slot:selection="data">
                                    <v-chip
                                      v-bind="data.attrs"
                                      :input-value="data.selected"
                                      close
                                      @click="data.select"
                                      @click:close="rvCategorie(data.item)"
                                    >
                                      {{ data.item.name }}
                                    </v-chip>
                                  </template>
                                  <template v-slot:item="data">
                                    <template
                                      v-if="typeof data.item !== 'object'"
                                      @click="addCategorie(data.item)"
                                    >
                                      <v-list-item-content
                                        v-text="data.item"
                                      ></v-list-item-content>
                                    </template>
                                    <template v-else>
                                      <v-list-item-content
                                        @click="addCategorie(data.item)"
                                      >
                                        <v-list-item-title
                                          v-html="data.item.name"
                                        ></v-list-item-title>
                                      </v-list-item-content>
                                    </template>
                                  </template>
                                </v-autocomplete>
                              </template>
                            </ApolloQuery>
                          </v-col>
                          <v-col cols="6" md="6">
                            <v-text-field
                              v-model="editedItem.name"
                              id="name"
                              label="Nome*"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.active_substance"
                              id="active_substance"
                              label="Substância ativa"
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.type"
                              id="type"
                              label="Tipo"
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.ean1"
                              id="ean1"
                              label="Cod. de Barras*"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-select
                              v-model="editedItem.stripe"
                              :items="tarjas"
                              item-text="text"
                              item-value="value"
                              id="stripe"
                              label="Tarja"
                            ></v-select>

                            <v-textarea
                              v-model="editedItem.description"
                              id="description"
                              label="Descrição"
                            >
                            </v-textarea>
                          </v-col>
                          <v-col cols="6" md="6">
                            <v-text-field
                              v-model="editedItem.brand"
                              id="brand"
                              label="Fabricante"
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.therapeutic_class"
                              id="therapeutic_class"
                              label="Classe terapêutica"
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.ean2"
                              id="ean2"
                              label="Cod. de Barras 2"
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.ms"
                              id="ms"
                              label="MS"
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.cnpj"
                              id="cnpj"
                              label="CNPJ"
                              v-mask="'##.###.###/####-##'"
                            >
                            </v-text-field>

                            <v-textarea
                              v-model="editedItem.information"
                              id="information"
                              label="Informação*"
                            >
                            </v-textarea>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                      :disabled="!valid"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="dialog_preco"
                max-width="500px"
                v-if="
                  user_role &&
                    (user_role.role == 'owner' || user_role.role == 'admin')
                "
              >
                <v-card>
                  <v-card-title>
                    <span class="headline">Preço</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form
                        ref="form"
                        v-model="valid_preco"
                        :lazy-validation="lazy"
                      >
                        <v-row>
                          <v-autocomplete
                            v-model="editedItem_preco.id_product"
                            v-bind:items="toArray(list_products)"
                            id="id_product"
                            label="Produto*"
                            item-text="name"
                            item-value="id"
                            :disabled="
                              editedItem_preco.id !== null ? true : false
                            "
                            :rules="rules"
                            :filter="searchProduct"
                            cache-items
                            required
                          >
                            <template slot="selection" slot-scope="data">
                              {{ data.item.name }} / {{ data.item.ean1 }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.name }} / {{ data.item.ean1 }}
                            </template>
                          </v-autocomplete>

                          <v-autocomplete
                            v-model="editedItem_preco.id_drugstore"
                            v-bind:items="toArray(list_drugstores)"
                            :disabled="
                              filters.id_drugstore !== null ? true : false
                            "
                            id="id_drugstore"
                            label="Farmácia*"
                            item-text="name"
                            item-value="id"
                            :rules="rules"
                            required
                          >
                          </v-autocomplete>

                          <v-text-field
                            v-model="editedItem_preco.cost"
                            id="cost"
                            label="Preço de compra"
                            :prefix="'R$'"
                            :rules="rulesMoney"
                          >
                          </v-text-field>

                          <v-text-field
                            v-model="editedItem_preco.retail"
                            id="retail"
                            label="Preço de venda"
                            :prefix="'R$'"
                            :rules="rulesMoney"
                            required
                          >
                          </v-text-field>

                          <v-text-field
                            v-model="editedItem_preco.storage"
                            id="storage"
                            label="Estoque"
                            required
                          >
                          </v-text-field>

                          <v-select
                            v-model="editedItem_preco.issale"
                            :items="[
                              { text: 'Sim', value: true },
                              { text: 'Não', value: false }
                            ]"
                            item-text="text"
                            item-value="value"
                            id="issale"
                            label="Em promoção"
                          ></v-select>

                          <v-menu
                            v-if="editedItem_preco.issale"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="dateFormated"
                                label="Validade da Promoção"
                                readonly
                                @blur="
                                  editedItem_preco.expiration = parseDate(
                                    dateFormated
                                  )
                                "
                                v-on="on"
                                required
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem_preco.expiration"
                              @input="menu = false"
                            ></v-date-picker>
                          </v-menu>

                          <v-text-field
                            v-if="editedItem_preco.issale"
                            v-model="editedItem_preco.discount"
                            :prefix="'R$'"
                            id="discount"
                            label="Preço em Promoção"
                            :rules="rulesMoney"
                          >
                          </v-text-field>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save_preco"
                      :disabled="!valid_preco"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-col cols="12">
                <v-row>
                  <h4>Informativo</h4>
                </v-row>
                <v-row>
                  {{ item.information | trim }}
                </v-row>
                <v-row class="pt-3">
                  <h4>Descrição</h4>
                </v-row>
                <v-row class="text-justify">
                  {{ item.description | trim }}
                </v-row>
              </v-col>
            </td>
          </template>
          <template v-slot:[`item.description`]="{ item }">
            <v-icon small @click="viewDescription(item.description)"
              >remove_red_eye</v-icon
            >
          </template>
          <template v-slot:[`item.information`]="{ item }">
            <v-icon small @click="viewInformation(item.information)"
              >remove_red_eye</v-icon
            >
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <!--div v-if="user_role && user_role.role == 'admin'" @click="editItem(item)" style="cursor: pointer;"><v-icon small class="mr-2">edit</v-icon></div>
                        <div v-if="user_role && user_role.role == 'admin'" @click="deleteItem(item)" style="cursor: pointer;"><v-icon small>delete</v-icon></div>

                        <div v-if="user_role && (user_role.role == 'owner' || user_role.role == 'admin')" @click="editPreco(item)" style="cursor: pointer;"><v-icon small>attach_money</v-icon></div-->
            <div style="display: flex; align-content: space-between;">
              <v-icon
                v-if="user_role && user_role.role == 'admin'"
                small
                class="mr-2"
                @click="editItem(item)"
                >edit</v-icon
              >
              <v-icon
                v-if="user_role && user_role.role == 'admin'"
                small
                @click="deleteItem(item)"
                >delete</v-icon
              >
              <v-icon
                v-if="
                  user_role &&
                    (user_role.role == 'owner' || user_role.role == 'admin')
                "
                small
                @click="editPreco(item)"
                >attach_money</v-icon
              >
            </div>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogDescription" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Descrição</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-flex xs12 sm12 md12>
                  {{ description }}
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn
                color="blue darken-1"
                text
                @click="dialogDescription = null"
                >Fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogInformation" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Informações</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-flex xs12 sm12 md12>
                  {{ information }}
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn
                color="blue darken-1"
                text
                @click="dialogInformation = false"
                >Fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogBanner" max-width="500px">
          <BannerAdd v-bind:price="price" />
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  GetProducts,
  DeleteProducts,
  InsertProducts,
  UpdateProducts,
  GetProductPrice,
  DeleteProductsCategories,
  InsertProductsCategories
} from "../../graphql/products.graphql";
import { InsertPrices, UpdatePrices } from "../../graphql/prices.gql";
//import { GetCategories } from "../../graphql/categories.gql";
import VueJwtDecode from "vue-jwt-decode";
//import store from "../../store.js";
import { VMoney } from "v-money";
import gql from "graphql-tag";
import BannerAdd from "../banners/BannerAdd";

//const self = this;

let date = new Date();
export default {
  props: ["tipo"],
  name: "products-list",
  directives: { money: VMoney },
  data: vm => ({
    // pagination: {
    //     page: 1,
    //     itemsPerPage: 10,
    //     pageStart: 1,
    //     pageStop: 1,
    //     pageCount: 1,
    //     itemsLength: 1,
    // },
    dialog: false,
    dialogBanner: false,
    dialogDescription: false,
    dialogInformation: false,
    price: null,
    information: null,
    description: null,
    valid: true,
    valid_preco: true,
    lazy: false,
    menu: false,
    dialog_preco: false,
    user_role: [],
    list_products: [],
    list_drugstores: [],
    tarjas: [
      { text: "Sem tarja", value: "Venda Livre" },
      { text: "Vermelha", value: "Tarja Vermelha" },
      {
        text: "Vermelha (com retenção da receita)",
        value: "Vermelha Retencao"
      },
      { text: "Preta", value: "Tarja Preta" }
    ],
    titulo: "Produtos",
    dateFormated: vm.formatDate(
      new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .substr(0, 10)
    ),
    arrayCategories: [],
    filters: {
      name: null,
      brand: null,
      description: null,
      stripe: null,
      active_substance: null,
      information: null,
      ean1: null,
      ean2: null,
      ms: null,
      enabled: null,
      issale: null,
      id_drugstore: null
    },
    headers: [
      { text: "Nome", value: "name" },
      { text: "Fabricante", value: "brand" },
      { text: "Tarja", value: "stripe" },
      { text: "Cod. de Barras", value: "ean1" },
      { text: "Ações", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      name: null,
      description: null,
      brand: null,
      active_substance: null,
      ean1: null,
      ean2: null,
      information: null,
      ms: null,
      cnpj: null,
      stripe: null,
      therapeutic_class: null,
      type: null,
      products_categories: []
    },
    defaultItem: {
      id: null,
      name: null,
      description: null,
      brand: null,
      active_substance: null,
      ean1: null,
      ean2: null,
      information: null,
      ms: null,
      cnpj: null,
      stripe: null,
      therapeutic_class: null,
      type: null,
      products_categories: []
    },
    editedIndex_preco: -1,
    editedItem_preco: {
      id: null,
      cost: "",
      retail: "",
      id_product: null,
      discount: 0.0,
      expiration: new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .substr(0, 10),
      issale: false,
      percent: null,
      enabled: true,
      id_drugstore: null,
      storage: 0
    },
    defaultItem_preco: {
      id: null,
      cost: "",
      retail: "",
      id_product: null,
      discount: 0.0,
      expiration: new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .substr(0, 10),
      issale: false,
      percent: null,
      enabled: true,
      id_drugstore: null,
      storage: 0
    },
    rules: [v => !!v || "Campo obrigatório!"],
    rulesMoney: [
      //v => (v || ',').indexOf(',') < 0 || 'Valor inválido!. Ex: "1.5" ou "1".'
    ],
    money: {
      decimal: ".",
      thousands: "",
      prefix: "",
      suffix: "",
      precision: 2,
      masked: false
    }
  }),

  components: {
    BannerAdd
  },

  filters: {
    trim: function(value) {
      if (value) return value.trim();
    }
  },
  
  apollo: {
    products: {
      query: GetProducts,
      variables() {
        return {
          name: this.filters.name
            ? { _ilike: "%" + this.filters.name + "%" }
            : {},
          brand: this.filters.brand
            ? { _ilike: "%" + this.filters.brand + "%" }
            : {},
          description: this.filters.description
            ? { _ilike: "%" + this.filters.description + "%" }
            : {},
          stripe: this.filters.stripe
            ? { _ilike: "%" + this.filters.stripe + "%" }
            : {},
          active_substance: this.filters.active_substance
            ? { _ilike: "%" + this.filters.active_substance + "%" }
            : {},
          therapeutic_class: {},
          information: this.filters.information
            ? { _ilike: "%" + this.filters.information + "%" }
            : {},
          ean1: this.filters.ean1 ? { _eq: this.filters.ean1 } : {},
          ean2: this.filters.ean2 ? { _eq: this.filters.ean2 } : {},
          ean3: this.filters.ean3 ? { _eq: this.filters.ean3 } : {},
          enabled: this.filters.enabled ? { _eq: this.filters.enabled } : {},
          issale: this.filters.issale ? { _eq: this.filters.issale } : {},
          id_drugstore: this.filters.id_drugstore
            ? { _eq: this.filters.id_drugstore }
            : {}
          // offset: 0
        };
      },
      skip() {
        return !this.filters.id_drugstore;
      },
      fetchPolicy: "cache-and-network"
      // update: (data) => {
      //     let pagination = {
      //         page: 2,
      //         itemsPerPage: 10,
      //         pageStart: 1,
      //         pageStop: Math.ceil(data.products_aggregate.aggregate.count/10),
      //         pageCount: 1,
      //         itemsLength: 1,
      //     };
      //     //Vue.set(this,"pagination",pagination);
      //     return data.products;
      // }
    }
  },

  filters: {
    trim: function(value) {
      if (value) return value.trim();
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Produto" : "Editar Produto";
    }
  },

  mounted: function() {
    if (localStorage.token) {
      this.user_role = VueJwtDecode.decode(localStorage.token);
    }

    if (this.tipo == "ativos") {
      this.titulo = "Produtos Ativos";
      this.filters.enabled = true;
      this.filters.issale = null;
    }
    if (this.tipo == "promocao") {
      this.titulo = "Produtos em Promoção";
      this.filters.enabled = null;
      this.filters.issale = true;
    } else if (this.tipo == "todos") {
      this.titulo = "Produtos";
      this.filters.enabled = null;
      this.filters.issale = null;
    }

    this.$apollo
      .query({
        query: gql`
          query ListDrugstores {
            drugstores(where: { enabled: { _eq: true } }) {
              id
              name
              location
              description
              enabled
              hasdelivery
              address
            }
            products: products(order_by: { name: asc }) {
              id
              name
              ean1
              ean2
            }
          }
        `
      })
      .then(data => {
        if (data.data.drugstores) {
          this.list_drugstores = data.data.drugstores;
        }
        if (data.data.products) {
          this.list_products = data.data.products;
        }
      });
  },

  watch: {
    tipo() {
      if (this.tipo == "ativos") {
        this.titulo = "Produtos Ativos";
        this.filters.enabled = true;
        this.filters.issale = null;
      }
      if (this.tipo == "promocao") {
        this.titulo = "Produtos em Promoção";
        this.filters.enabled = null;
        this.filters.issale = true;
      } else if (this.tipo == "todos") {
        this.titulo = "Produtos";
        this.filters.enabled = null;
        this.filters.issale = null;
      }
    },

    dialog(val) {
      val || this.close();
    },
    "editedItem_preco.expiration": {
      deep: true,
      handler() {
        this.dateFormated = this.formatDate(this.editedItem_preco.expiration);
      }
    },
    "filters.name": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.name = null;
          }
        }
      }
    },
    "filters.description": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.description = null;
          }
        }
      }
    },
    "filters.information": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.information = null;
          }
        }
      }
    },
    "filters.brand": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.brand = null;
          }
        }
      }
    },
    "filters.stripe": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.stripe = null;
          }
        }
      }
    },
    "filters.active_substance": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.active_substance = null;
          }
        }
      }
    },
    "filters.ean1": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.ean1 = null;
          }
        }
      }
    },
    "filters.ean2": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.ean2 = null;
          }
        }
      }
    },
    "filters.id_drugstore": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.id_drugstore = null;
          }
        }
      }
    },
    arrayCategories(val) {
      if (typeof val !== "undefined" && val !== null) {
        var self = this;
        this.editedItem.products_categories = [];

        val.forEach(function(element) {
          var id = element.id ? element.id : element;
          if (self.editedItem.id) {
            self.editedItem.products_categories.push({
              id_categorie: id,
              id_product: self.editedItem.id
            });
          } else {
            self.editedItem.products_categories.push({ id_categorie: id });
          }
        });
      }
    }
  },

  methods: {
    searchProduct(item, queryText) {
      return (
        item.name.toLowerCase().indexOf(queryText) > -1 ||
        item.ean1.indexOf(queryText) > -1
      );
    },

    addCategorie(item) {
      var parent_ids = [];

      if (item.category) {
        if (item.category) {
          //Categoria nv1
          parent_ids.push(item.category.id);
          if (item.category.category) {
            //Categoria nv2
            parent_ids.push(item.category.category.id);
            if (item.category.category.category) {
              //Categoria nv3
              parent_ids.push(item.category.category.category.id);
              if (item.category.category.category.category) {
                //Categoria nv4
                parent_ids.push(item.category.category.category.category.id);
              }
            }
          }
        }
      }

      if (this.editedItem.id !== null) {
        this.$apollo
          .mutate({
            mutation: InsertProductsCategories,
            variables: {
              id_product: this.editedItem.id,
              id_categorie: item.id
            }
          })
          .then(data => {
            this.$apollo.data.products[
              this.editedIndex
            ].products_categories.push(
              data.data.insert_products_categories.returning[0]
            );
          })
          .catch(() => {});

        if (parent_ids.length) {
          //Remove os ids já cadastrados
          for (var i = 0; i < this.arrayCategories.length; i++) {
            if (
              this.inArray(this.arrayCategories[i].id, parent_ids) ||
              this.inArray(this.arrayCategories[i], parent_ids)
            ) {
              parent_ids.splice(
                parent_ids.indexOf(this.arrayCategories[i].id),
                1
              );
            }
          }

          //Adiciona as categorias pais
          for (let i = 0; i < parent_ids.length; i++) {
            let parent_id = parent_ids[i];

            this.$apollo
              .mutate({
                mutation: InsertProductsCategories,
                variables: {
                  id_product: this.editedItem.id,
                  id_categorie: parent_id
                }
              })
              .then(data => {
                this.$apollo.data.products[
                  this.editedIndex
                ].products_categories.push(
                  data.data.insert_products_categories.returning[0]
                );
                this.arrayCategories.push({ id: parent_id });
              })
              .catch(() => {});
          }
        }
      } else {
        if (parent_ids.length) {
          //Remove os ids já cadastrados
          for (let i = 0; i < this.arrayCategories.length; i++) {
            if (
              this.inArray(this.arrayCategories[i].id, parent_ids) ||
              this.inArray(this.arrayCategories[i], parent_ids)
            ) {
              this.arrayCategories.splice(i, 1);
            }
          }

          //Adiciona as categorias pais
          for (let i = 0; i < parent_ids.length; i++) {
            this.arrayCategories.push({ id: parent_ids[i] });
          }
        }
      }
    },

    rvCategorie(item) {
      for (let i = 0; i < this.arrayCategories.length; i++) {
        if (
          this.arrayCategories[i].id === item.id ||
          this.arrayCategories[i] === item.id
        ) {
          this.arrayCategories.splice(i, 1);
        }
      }

      if (this.editedItem.id !== null) {
        this.$apollo
          .mutate({
            mutation: DeleteProductsCategories,
            variables: {
              id_product: this.editedItem.id,
              id_categorie: item.id
            }
          })
          .then(() => {
            for (
              var i = 0;
              i <
              this.$apollo.data.products[this.editedIndex].products_categories
                .length;
              i++
            ) {
              if (
                this.$apollo.data.products[this.editedIndex]
                  .products_categories[i].id_categorie === item.id
              ) {
                this.$apollo.data.products[
                  this.editedIndex
                ].products_categories.splice(i, 1);
              }
            }
          })
          .catch(() => {});
      }
    },

    viewInformation(data) {
      this.dialogInformation = true;
      this.information = data;
    },

    viewDescription(data) {
      this.dialogDescription = true;
      this.description = data;
    },

    clear(value) {
      if (!value) {
        return null;
      }
    },

    editItem(item) {
      this.editedIndex = this.$apollo.data.products.indexOf(item);
      this.editedItem = Object.assign({}, item);

      var self = this;
      this.editedItem.products_categories = [];
      this.arrayCategories = [];

      item.products_categories.forEach(function(element) {
        if (typeof element !== "undefined") {
          self.arrayCategories.push({ id: element.id_categorie });
        }
      });

      this.dialog = true;
    },

    editPreco(item) {
      this.$apollo
        .query({
          query: GetProductPrice,
          variables: {
            id_product: item.id
          }
        })
        .then(data => {
          if (data.data.prices.length > 0) {
            this.editedItem_preco = Object.assign({}, data.data.prices[0]);
          }

          this.editedItem_preco.id_product = item.id;

          /* if (
            this.user_role.role == "owner" &&
            this.user_role.drugstore_ids.length == 1
          ) {
            this.editedItem_preco.id_drugstore = parseInt(
              this.user_role.drugstore_ids[0]
            );
          }*/

          this.editedItem_preco.id_drugstore = this.filters.id_drugstore;

          this.editedIndex_preco = this.$apollo.data.products.indexOf(item);

          this.dialog_preco = true;
        })
        .catch(() => {});
    },

    deleteItem(item) {
      const index = this.$apollo.data.products.indexOf(item);
      confirm("Deletar produto?") &&
        this.$apollo.data.products.splice(index, 1) &&
        this.$apollo
          .mutate({
            mutation: DeleteProducts,
            variables: {
              id: item.id
            }
          })
          .then(() => {
            this.$swal("Produto deletada com sucesso!", "", "success");
          })
          .catch(() => {
            this.$swal("Erro ao deletar produto!", "", "error");
          });
    },

    close() {
      this.dialog = false;
      this.dialog_preco = false;
      this.arrayCategories = [];
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem_preco = Object.assign({}, this.defaultItem_preco);
      this.editedIndex = -1;
      this.editedIndex_preco = -1;
    },

    save() {
      let variables = {
        name: this.editedItem.name,
        description: this.editedItem.description,
        brand: this.editedItem.brand,
        active_substance: this.editedItem.active_substance,
        ean1: this.editedItem.ean1,
        ean2: this.editedItem.ean2,
        ean3: this.editedItem.ean3,
        information: this.editedItem.information,
        ms: this.editedItem.ms,
        cnpj: this.editedItem.cnpj,
        stripe: this.editedItem.stripe,
        therapeutic_class: this.editedItem.therapeutic_class,
        type: this.editedItem.type
      };

      if (this.editedItem.id === null) {
        variables.products_categories = this.editedItem.products_categories;
      } else {
        variables.id = this.editedItem.id;
      }

      this.$apollo
        .mutate({
          // Query
          mutation:
            this.editedItem.id !== null ? UpdateProducts : InsertProducts,
          // Parameters
          variables: variables
        })
        .then(data => {
          if (this.editedItem.id !== null) {
            Object.assign(
              this.$apollo.data.products[this.editedIndex],
              data.data.update_products.returning[0]
            );
          } else {
            this.$apollo.data.products.push(
              data.data.insert_products.returning[0]
            );
          }
          this.close();
          this.$swal("Produto salvo com sucesso!", "", "success");
        })
        .catch(error => {
          console.log(error);
          this.close();
          this.$swal("Erro ao salvar o produto!", "", "error");
        });
    },

    save_preco() {
      let variables = {
        cost: this.editedItem_preco.cost,
        id_product: this.editedItem_preco.id_product,
        id_drugstore: this.editedItem_preco.id_drugstore,
        retail: this.editedItem_preco.retail,
        discount: this.editedItem_preco.discount,
        percent: this.editedItem_preco.percent,
        expiration: this.editedItem_preco.expiration,
        issale: this.editedItem_preco.issale,
        enabled: this.editedItem_preco.enabled,
        storage: this.editedItem_preco.storage
      };

      if (this.editedItem_preco.id !== null) variables.id = this.editedItem_preco.id;

      this.$apollo
        .mutate({
          // Query
          mutation:
            this.editedItem_preco.id !== null ? UpdatePrices : InsertPrices,
          // Pass params dynamically
          variables: variables
        })
        .then(() => {
          if (this.editedItem_preco.id !== null) {
            //Object.assign(this.$apollo.data.prices[this.editedIndex], data.data.update_prices.returning[0]);
          } else {
            //this.$apollo.data.prices.push(data.data.insert_prices.returning[0]);
          }
          this.close();
          this.$swal("Preço salvo com sucesso!", "", "success");
        })
        .catch(error => {
          console.log(error);
          this.close();
          this.$swal("Erro ao salvar o preço!", "", "error");
        });
    },

    toArray(array) {
      let items = [];
      array.forEach(v => items.push(v));
      return items;
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    inArray: function(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    }
  }
};
</script>

<style lang="stylus"></style>
